import tw from 'tailwind-styled-components'

export const LayoutContent = tw.div`
${({ $hasTitle }) =>
  $hasTitle ? 'h-full-height-with-title' : 'h-full-height-without-title'}
  ${({ $bgNeutral }) => ($bgNeutral ? 'bg-neutral-100' : '')}
  px-8
`
